import { render, staticRenderFns } from "./Snackbar.vue?vue&type=template&id=6b767e29&scoped=true&"
import script from "./Snackbar.vue?vue&type=script&lang=js&"
export * from "./Snackbar.vue?vue&type=script&lang=js&"
import style0 from "./Snackbar.vue?vue&type=style&index=0&id=6b767e29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b767e29",
  null
  
)

export default component.exports